import CloseIcon from '@/icons/CloseIcon';
import { useMemo } from 'react';
import { type FilterOption, type Filter } from './Locator.types';

export type LocatorMobileFiltersProps = {
  filterOptions: FilterOption;
  filters: Filter;
  onClearFilter?: (filter: string, target: string | Array<string>) => void;
  onFiltersClick: () => void;
};

const LocatorMobileFilters: React.FC<LocatorMobileFiltersProps> = ({
  filterOptions,
  filters,
  onClearFilter,
  onFiltersClick,
}) => {
  const addLabeList = (selectedList, originalList) => {
    const result = [];

    selectedList.map((selectedValue) => {
      const newObj = originalList.find((obj) => obj.value === selectedValue);

      result.push(newObj);
    });

    return result;
  };

  const addLabel = (selected, originalList) => {
    if (selected) {
      const newObj = originalList.find((obj) => obj.value === selected);

      return newObj;
    }
  };
  const { fuel, services, type } = filters;
  const { fuels, services: serviceOptions, types } = filterOptions;
  const labeledServicesFilters = useMemo(
    () => addLabeList(services, serviceOptions),
    [filters],
  );
  const labeledFuelsFilters = useMemo(() => addLabel(fuel, fuels), [filters]);
  const labeledTypesFilters = useMemo(() => addLabel(type, types), [filters]);

  return (
    <div className="locator-mobile-filters">
      <div className="locator-mobile-filters__container container">
        <button
          className="locator-mobile-filters__button"
          onClick={onFiltersClick}
        >
          Filters
        </button>
        <ul className="locator-mobile-filters__filters">
          {services.length > 0 &&
            labeledServicesFilters.map((labeledService, i) => (
              <li className="locator-mobile-filters__filter" key={i}>
                {labeledService.label}
                <button
                  className="locator-mobile-filters__filter-clear"
                  onClick={() =>
                    onClearFilter(
                      'services',
                      services.filter(
                        (service) => service !== labeledService.value,
                      ),
                    )
                  }
                >
                  <CloseIcon fill="#1E196A" size={12} />
                </button>
              </li>
            ))}
          {type && labeledTypesFilters && (
            <li className="locator-mobile-filters__filter">
              {labeledTypesFilters.label}
              <button
                className="locator-mobile-filters__filter-clear"
                onClick={() => onClearFilter('type', '')}
              >
                <CloseIcon fill="#1E196A" size={12} />
              </button>
            </li>
          )}
          {fuel && labeledFuelsFilters && (
            <li className="locator-mobile-filters__filter">
              {labeledFuelsFilters.label}
              <button
                className="locator-mobile-filters__filter-clear"
                onClick={() => onClearFilter('fuel', '')}
              >
                <CloseIcon fill="#1E196A" size={12} />
              </button>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default LocatorMobileFilters;
